export const DEPRECATE_SHOW_EXHIBITOR_DETAILS_PATH =
  "/shows/:showId/exhibitors/:exhibitorId/stand/:standId";
export const DEPRECATE_SHOW_COMPANY_DETAILS_PATH =
  "/shows/:showId/companies/:companyId/stand/:standId";

export const DEPRECATE_SHOW_EXHIBITOR_INFO_PATH =
  "/shows/:showId/stand/:standId/show-info";
export const DEPRECATE_SHOW_EXHIBITOR_SETTINGS_PATH =
  "/shows/:showId/stand/:standId/settings";
export const DEPRECATE_SHOW_EXHIBITOR_ORDERS_PATH =
  "/shows/:showId/stand/:standId/orders";
export const DEPRECATE_SHOW_EXHIBITOR_USERS_PATH =
  "/shows/:showId/stand/:standId/users";
export const DEPRECATE_SHOW_EXHIBITOR_CART_PATH =
  "/shows/:showId/stand/:standId/cart";
export const DEPRECATE_SHOW_EXHIBITOR_QUICK_CART_PATH =
  "/shows/:showId/stand/:standId/quick-cart";
export const DEPRECATE_SHOW_EXHIBITOR_CART_PAYMENT_PATH =
  "/shows/:showId/stand/:standId/cart/:orderId";
export const DEPRECATE_SHOW_EXHIBITOR_SHOPPING_PATH =
  "/shows/:showId/stand/:standId/shopping";
export const DEPRECATE_SHOW_EXHIBITOR_TASKS_PATH =
  "/shows/:showId/stand/:standId/tasks";
export const DEPRECATE_SHOW_EXHIBITOR_DASHBOARD_PATH =
  "/shows/:showId/stand/:standId/dashboard";
export const DEPRECATE_SHOW_EXHIBITOR_ORDER_DETAILS_PATH =
  "/shows/:showId/stand/:standId/orders/:orderId";

export const APP_PATH = "/";
export const SHOWS_PATH = "/";
export const SESSION_CHANGED_PATH = "/session-changed";
export const FORGOT_PASSWORD = "/forgot-password";
export const RESET_PASSWORD = "/reset-password";
export const RECOVERY_CODE_CONFIRMATION_PATH = "/recovery-code-confirmation";
export const LOGIN_PATH = "/login";
export const ADMIN_LOGIN_PATH = "/admin/login";
export const LOGIN_ONCE_PATH = "/login/once";
export const LOGIN_SSO_PATH = "/login/sso";
export const SETTINGS_PATH = "/settings";
export const SETTINGS_SECURITY_PATH = "/settings/security";
export const ADMIN_FEATURES_PATH = "/features";
export const ADMIN_PRO_FEATURES_PATH = "/pro-features";
export const ADMIN_COUNTRIES_PATH = "/countries";
export const SIGNUP_EXHIBITOR_PATH = "/sign-up/exhibitor";
export const SIGNUP_DEPRECATED_EXHIBITOR_PATH = "/sign-up/deprecated/exhibitor";
export const SIGNUP_DEPRECATED_UID_PATH = "/sign-up/:uid";
export const SIGNUP_PATH = "/sign-up";
export const SHOW_DETAILS_PATH = "/shows/:showId";
export const SHOW_BULK_UPLOAD_PATH = "/shows/:showId/bulk-upload";
export const SHOW_DASHBOARD_PATH = "/shows/:showId/dashboard";
export const SHOW_EXHIBITORS_PATH = "/shows/:showId/exhibitors";
export const EXHIBITORS_PATH = "/exhibitors";
export const CHANGE_EMAIL = "/change-email";
export const SHOW_CUSTOM_REPORTS_PATH = "/shows/:showId/custom-reports";
export const SHOW_EXHIBITOR_PAIR_DETAILS_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId";
export const SHOW_ORDERS_PATH = "/shows/:showId/orders";
export const SHOW_SUPPLIERS_PATH = "/shows/:showId/suppliers";
export const SHOW_PACKAGES_PATH = "/shows/:showId/packages";
export const SHOW_ACTIVITY_FEED_PATH = "/shows/:showId/activity-feed";
export const SHOW_USERS_PATH = "/shows/:showId/users";
export const SHOW_TASK_REVIEW_PATH = "/shows/:showId/task-review";
export const SHOW_ONLINE_MANUAL_PATH = "/shows/:showId/tasks";
export const SHOW_MESSAGING_BOARD = "/shows/:showId/messaging-board";
export const SHOW_INFO_PATH = "/shows/:showId/show-info";
export const PURCHASE_PATH = "/shows/:showId/purchase";
/**
 * Buying a Show language before the Show exists — the Add Show form has no
 * `:showId` to hang the purchase off, so this one lives at the top level.
 */
export const LANGUAGE_PURCHASE_PATH = "/purchase/language";
/**
 * Same idea for any per-show paid feature (`?priceName=<PaidFeatureEnum>`):
 * bought from the Add Show form, held for the next Show the company creates.
 */
export const PAID_FEATURE_PURCHASE_PATH = "/purchase/paid-feature";
export const SHOW_ACCESS_PATH = "/shows/:showId/access";
export const SHOW_CUSTOM_EMAIL_PREVIEW_PATH =
  "/shows/:showId/custom-email-preview";
export const SHOW_SETTINGS_PATH = "/shows/:showId/settings";
export const SHOW_PRODUCTS_LIST_PATH = "/shows/:showId/products";
export const SUPPLIERS_LIST_PATH = "/suppliers";
export const LIBRARIES_PATH = "/libraries";
// Opened in a new tab from `Libraries › Show Info`: the company's master manual
// rendered unfiltered — no Show, so no build-type filter and no language switch.
export const SHOW_INFO_LIBRARY_PREVIEW_PATH = "/libraries/show-info/preview";
export const EMAIL_TASK_REVIEW_PATH = "/task/email-review";
// Legacy pre-FS-2679 path still baked into already-sent reviewer emails.
// Aliased to the same page so old links can recover via the resend flow.
export const LEGACY_EMAIL_TASK_REVIEW_PATH = "/email-task-review";
export const ALL_TASK_REVIEW_PATH = "/all-task-review";
export const ANONYMOUS_SHOW_INFO_PAGE_PATH = "/show-info/:showId";
export const SHOWS_LIST_PATH = "/shows";
export const ONLINE_MANUALS_PATH = "/online-manuals";
export const USERS_PATH = "/users";
export const ORGANISERS_LIST_PATH = "/organisers";
export const PRODUCTS_LIST = "/products";
export const CUSTOM_OPTIONS_PATH = "/custom-options";
export const PRODUCTS_BULK_UPLOAD_PATH = "/bulk-upload";
export const OUTSTANDING_PAYMENTS_PATH = "/outstanding-payments";
export const SHOW_ORGANISER_SHOPPING_PATH = "/shows/:showId/shopping";
export const BRANDING_PREVIEW_PATH = "/shows/:showId/branding-preview";
export const SHOW_EXHIBITOR_PATH = "/shows/:showId/stand/:standId";
export const SHOW_INFO_EXHIBITOR_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId/show-info";
export const SHOW_EXHIBITOR_ORDERS_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId/orders";
export const SHOW_EXHIBITOR_USERS_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId/users";
export const SHOW_EXHIBITOR_CART_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId/cart";
export const SHOW_EXHIBITOR_QUICK_CART_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId/quick-cart";
export const SHOW_EXHIBITOR_CART_PAYMENT_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId/cart/:orderId";
export const SHOW_EXHIBITOR_SHOPPING_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId/shopping";
export const SHOW_EXHIBITOR_TASKS_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId/tasks";
export const PREVIEW_TASK_GRID_PATH = "/shows/:showId/preview-grid";
export const SHOW_EXHIBITOR_DASHBOARD_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId/dashboard";
export const SHOW_EXHIBITOR_ORDER_DETAILS_PATH =
  "/shows/:showId/exhibitor-pair/:exhibitorPairId/orders/:orderId";
// NOTE: Old external redirect path
export const REDIRECT_TO_ASP_PATH = "/shows/:showId/redirect-to-asp";
export const SHOW_EXTERNAL_REDIRECT = "/shows/:showId/external-redirect";
export const EMBEDDED_SHOWS_PATH = "/embedded-shows/:token";
export const EMAIL_TEMPLATE_PREVIEW_PATH = "/email-templates/:emailTemplateId";
export const PAYMENT_REMINDER_PREVIEW_PATH = "/payment-reminder-preview";
export const LANGUAGE_SETTINGS_PATH = "/language-settings";

// Routes reachable without the authenticated role-based app shell
// (login / sign-up, anonymous previews, embedded & public pages). Shared
// components (modals, drawers) can mount on these pages, so authenticated-only
// side effects — e.g. fetching the current show for embedded chat — must stay
// disabled here. Use `isPublicRoute()` (tools/routing/isPublicRoute) to match
// the current pathname against this list.
export const PUBLIC_ROUTE_PATHS: string[] = [
  ADMIN_LOGIN_PATH,
  LOGIN_PATH,
  LOGIN_SSO_PATH,
  LOGIN_ONCE_PATH,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  RECOVERY_CODE_CONFIRMATION_PATH,
  SESSION_CHANGED_PATH,
  SIGNUP_PATH,
  SIGNUP_EXHIBITOR_PATH,
  SIGNUP_DEPRECATED_UID_PATH,
  SIGNUP_DEPRECATED_EXHIBITOR_PATH,
  CHANGE_EMAIL,
  EMAIL_TASK_REVIEW_PATH,
  ALL_TASK_REVIEW_PATH,
  ANONYMOUS_SHOW_INFO_PAGE_PATH,
  EMAIL_TEMPLATE_PREVIEW_PATH,
  EMBEDDED_SHOWS_PATH,
  // Grid preview doubles as the anonymous target of the `?responseId=` link
  // baked into certificate / task-print PDFs — suppress authenticated-only
  // side effects so a logged-out viewer never triggers a session fetch.
  PREVIEW_TASK_GRID_PATH,
];
